import React from 'react';
import i18n from 'i18n/config';

const BadgeSocietyHolding = () => (
  <span className="badge bg-primary text-white">{i18n.t('Holding')}</span>
);

export default BadgeSocietyHolding;
